
import {defineComponent, onMounted, onBeforeMount, Ref, ref} from "vue";

import CatalogService from "@/services/CatalogService";
import {useStore} from './store';
import {FilterActionTypes} from './store/modules/filter/action-types';
import {ProductActionTypes} from "./store/modules/product/action-types";

import FilterHolder from "./components/filter/FilterHolder.vue";
import FilterSelection from "./components/filter/FilterSelection.vue";
import CategorySort from "./components/controls/CategorySort.vue";
import ProductList from "./components/products/ProductList.vue";
import Pager from "./components/controls/Pager.vue";

declare global {
  interface Window {
    preloadedProductsForVue: any | null
  }
}

export default defineComponent({
  name: "StoreCatalog",
  components: {
    FilterHolder,
    FilterSelection,
    CategorySort,
    ProductList,
    Pager
  },
  setup() {
    const root: Ref<HTMLElement | null> = ref(null)
    const isLoading: Ref<boolean> = ref(true)
    const store = useStore();

    onMounted(() => {
      const preloadedProducts = window?.preloadedProductsForVue
      if (preloadedProducts) {
        store.dispatch(ProductActionTypes.SET_PRODUCTS, preloadedProducts).then(() => isLoading.value = false);
      }
    })

    CatalogService.prepareFilterData()
        .then(result => {
          store.dispatch(FilterActionTypes.SET_FILTER, result);
          if (isLoading.value) {
            store.dispatch(ProductActionTypes.SET_PRODUCTS, result).then(() => isLoading.value = false);
          }
        })
        .catch(error => console.error(error))

    return {
      root,
      isLoading,
    }
  }
});
